module.exports = __webpack_public_path__ + "assets/start_off.6d2cd624.svg";